
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.498 24a.498.498 0 01-.487-.614l1.517-6.465a.494.494 0 01.133-.239l.239-.239a2343716182.845 2343716182.845 0 0013.587-13.59l.015-.014L17.609.732A2.482 2.482 0 0119.376 0c.668 0 1.296.26 1.768.732l2.123 2.121c.472.471.731 1.099.732 1.768 0 .668-.26 1.296-.731 1.768l-.681.681-.021.026a.363.363 0 01-.035.03L21.16 8.497l-.025.03a.254.254 0 01-.034.028L7.587 22.067a.142.142 0 01-.024.025.174.174 0 01-.014.012l-.232.232a.494.494 0 01-.239.133L.611 23.986A.427.427 0 01.498 24zm.671-1.171l5.213-1.223-3.99-3.99-1.223 5.213zm6.046-1.804L20.073 8.169 15.84 3.916 2.974 16.783l4.241 4.242zM20.78 7.462l.719-.719L17.256 2.5l-.708.708 4.232 4.254zm1.426-1.426l.354-.353a1.504 1.504 0 000-2.122L20.438 1.44A1.486 1.486 0 0019.377 1a1.49 1.49 0 00-1.061.44l-.354.354 4.244 4.242z"}})])
          )
        }
      }
    